.divider {
  margin: 0;
  flex-shrink: 0;
  border: none;
  border-bottom: thin solid var(--tuna-border-default);
}

.vertical {
  border-bottom: none;
  border-right: thin solid var(--tuna-border-default);
  align-self: stretch;
  height: auto;
}

.withText {
  display: flex;
  align-items: center;
  gap: 16px;
  border: none;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
  text-transform: uppercase;
}

.withText::before,
.withText::after {
  content: '';
  flex: 1;
  border-bottom: thin solid var(--tuna-border-default);
}
